export const extensionIdsByHostname = {
    'localhost': 'kjmkgbcfjaeplamjhbbmbadpennooike',
    'my.ohio.pf.dev': 'fpgbplibepikcnlnbkpklejopojghoaa',
    'my-pr.ohio.pf.dev': 'fpgbplibepikcnlnbkpklejopojghoaa',
    'app.productfruits.com': 'gfalakmkgcpgdbhkidmehfgcokbilime', // just to be sure, we use both prod domains
    'my.productfruits.com': 'gfalakmkgcpgdbhkidmehfgcokbilime', // just to be sure, we use both prod domains
};

export function getExtensionIdByHostname() {
    return extensionIdsByHostname[location.hostname];
}

export function sendMessageToExtensionAsync(msgObject) {
    return new Promise((resolve) => {
        console.log('here');
        chrome.runtime.sendMessage(getExtensionIdByHostname(), msgObject, function (response) {
            if (!chrome.runtime.lastError) {
                resolve(response);
            } else {
                resolve(null);
            }
        });
    });
}